import { gql } from '@apollo/client';

export * from './escrowUpdateDepositorNotifications.mutation.generated';

export const ESCROW_UPDATE_DEPOSITOR_NOTIFICATIONS = gql`
  mutation escrowUpdateDepositorNotifications(
    $escrowId: ID!
    $escrowParams: EscrowUpdateDepositorNotificationsParams!
  ) {
    escrowUpdateDepositorNotifications(input: { escrowId: $escrowId, escrowParams: $escrowParams }) {
      success
      errors
      escrow {
        id
        depositorActivityNotification
        depositorDisruptionNotification
        depositorDisruptionNotificationGracePeriod
      }
    }
  }
`;
